import {default as cx} from "classnames"
import {Button} from "react-bootstrap"

function SurveyNavigation({next, nextEnabled, previous, submit, submitting, isLastQuestion, isFirstStep}) {
    return (
        <div className="d-flex flex-stack fixed-bottom p-5 shadow-top bg-light">
            <div className="mr-2">
                <Button
                    className={cx("btn-light-primary btn-flex align-self-center", {
                        "d-none": isFirstStep,
                    })}
                    onClick={previous}
                >
                    <i className="fas fa-arrow-circle-left fs-3 me-1"></i>Back
                </Button>
            </div>
            <div>
                <Button
                    className={cx("btn-flex me-3", {"d-none": !isLastQuestion})}
                    onClick={submit}
                    disabled={!nextEnabled}
                >
                    {submitting ? (
                        <span>
                            Please wait... <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                        </span>
                    ) : (
                        <span>Submit</span>
                    )}
                </Button>
                <Button className={cx("btn-flex", {"d-none": isLastQuestion})} onClick={next} disabled={!nextEnabled}>
                    Next<i className="fas fa-arrow-circle-right ms-2 fs-3"></i>
                </Button>
            </div>
        </div>
    )
}
export default SurveyNavigation
